
import { defineComponent, onMounted, reactive } from "vue";
import { useRoute } from "vue-router";
import axios from "axios";

export default defineComponent({
  name: "notif-unsubscribe",
  setup() {
    const route = useRoute();
    const state = reactive({
      loading: true,
      ok: false,
      email: "",
    });

    onMounted(async () => {
      const token = String(route.params.token || "");
      if (!token) {
        state.loading = false;
        return;
      }

      try {
        const baseUrl = process.env.VUE_APP_BACK_URL || "";
        const response = await axios.get(
          `${baseUrl}/unsubscribeNotifTicket/${encodeURIComponent(token)}`,
          { withCredentials: true }
        );
        const result = response.data?.results || response.data;
        state.ok = !!result?.ok;
        state.email = result?.con_mail || "";
      } catch {
        state.ok = false;
      } finally {
        state.loading = false;
      }
    });

    return { state };
  },
});
